import { DDTechTypeEnum } from "../../../../utils/enum";
import { setAddressesValue } from "./setAddressesValue";
import { setPriValue } from "./setPriValue";
import { setPstnValue } from "./setPstnValue";
import { setWorkOrderManagementValue } from "./setWorkOrderManagementValue";

export const setOrderLines = (orderLines: any) => {
  const orderLineItem = orderLines.map(
    (orderLine: any, index: number) => `Sipariş ${index + 1}
      Ürün Kategorisi : ${orderLine.categoryName}
      ${orderLine.productTypeId ? "Ürün Tipi : " + orderLine.productName : ""}
      Kampanya : ${orderLine.campaignName}
      ${orderLine.paymentType && "İşlem Türü : " + orderLine.paymentType} 
      ${orderLine.serviceType ? "Servis Tipi : " + orderLine.serviceType : ""}
      ${
        orderLine.pstn
          ? "PSTN Numaraları : " + setPstnValue(orderLine.pstn)
          : ""
      }
      ${orderLine.bri ? setPriValue(orderLine.bri) : ""}
      ${orderLine.pri ? setPriValue(orderLine.pri) : ""}
      ${
        orderLine.internetAddress
          ? "Adresler" + setAddressesValue(orderLine.internetAddress)
          : ""
      }
  
      ${orderLine.lineType ? "Churn Tipi : " + orderLine.lineType : ""}
      ${orderLine.phoneNumber ? "Telefon No : " + orderLine.phoneNumber : ""}
      ${orderLine.circuitNumber ? "Devre No : " + orderLine.circuitNumber : ""}
      `
  );
  return orderLineItem;
  //return "Test";
};
